import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_ETA_CONTEXT = createContext();

class PlanItemETAProvider extends Component {
  state = { eta_planItems: undefined };

  unsubscribe = null;

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
    .where("state", "==", "e")
    .onSnapshot(snapshot => {
      const containerObjs = snapshot.docs.map(doc => {
        return { id: doc.id, routingContainerState: "e", ...doc.data()};
      });

      let notInvoicedList = containerObjs.filter(function (obj) {
        return obj.invoiced !== true;
      });

      notInvoicedList.sort((a, b) => Helper.compareDateLike(a.eta, b.eta));

      this.setState({ eta_planItems : notInvoicedList });
    });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ eta_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { eta_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_ETA_CONTEXT.Provider value={eta_planItems}>{children}</PLANITEM_ETA_CONTEXT.Provider>;
  }
}

export default PlanItemETAProvider;

PlanItemETAProvider.defaultProps = {
  branchCode: "NY",
};
